import { NotificationPermissionPrompt } from './NotificationPermissionPrompt';
import { usePortalWebPush } from '../../hooks/usePortalWebPush';

type Props = {
  /** `toast` = floating card, stays until user dismisses (DEM theme lab). */
  variant?: 'banner' | 'toast';
};

/** One-time enable prompt — subscription is shared across all portals on this device. */
export function PortalWebPushBanner({ variant = 'banner' }: Props) {
  const {
    setupState,
    showPermissionPrompt,
    enableNotifications,
    dismissPermissionPrompt,
    webPushConfigured,
  } = usePortalWebPush();

  if (!showPermissionPrompt) return null;

  return (
    <div
      className={
        variant === 'toast'
          ? 'notification-permission-toast-host'
          : undefined
      }
    >
      <NotificationPermissionPrompt
        setupState={setupState}
        onEnable={() => void enableNotifications()}
        onDismiss={dismissPermissionPrompt}
        webPushConfigured={webPushConfigured}
        className={variant === 'toast' ? 'notification-permission--toast' : undefined}
      />
    </div>
  );
}
